module.exports = __webpack_public_path__ + "static/img/aboutus_img.3fb99df.png";


//////////////////
// WEBPACK FOOTER
// ./static/mobile/aboutUs/aboutus_img.png
// module id = 3jmm
// module chunks = 0